module.exports = [{
    text: "Disabled",
    value: "Disabled",
},{
    text: "Spanish",
    value: "Spanish",
}];
